
/**
 * 공통 오류 응답
 */
export type InitiateSubscription401 = {
  /** 오류 코드 */
  errorCode: string;
  /** 오류 메시지 */
  message: string;
  /** 요청 경로 */
  path?: string;
  /** 성공 여부 (항상 false) */
  success: boolean;
  /** 오류 발생 시간 */
  timestamp: string;
};
